<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Pengambilan Merchandise
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-autocomplete
                  label="Merchandise"
                  required
                  dense
                  outlined
                  :items="listMerchandise"
                  item-text="name"
                  item-value="id"
                  v-model="data.merchandise_id"
                  :rules="rules.merchandise_id"
                ></v-autocomplete>
                <v-text-field
                  label="Diambil Oleh"
                  required
                  dense
                  outlined
                  v-model="data.merchandise_taken_by"
                  :rules="rules.merchandise_taken_by"
                ></v-text-field>
                <v-textarea
                  label="Deskripsi"
                  dense
                  outlined
                  v-model="data.description"
                ></v-textarea>
                <v-text-field
                  label="Jumlah "
                  type="number"
                  dense
                  outlined
                  v-model="data.amount"
                ></v-text-field>
                <date-picker
                      class="mb-6"
                      placeholder="Tanggal Pengambilan"
                      valueType="format"
                      :format="'YYYY-MM-DD'"
                      v-model="data.taken_date"
                      :rules="rules.taken_date"
                    ></date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

export default {
  async beforeMount() {
    this.listMerchandise = (
          await ApiService.get("merchandise/list")
        ).data;
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      listMerchandise: [],
      valid: true,
      data: {
        merchandise_taken_by: null,
        merchandise_id: null,
        amount: null,
        description: null,
        taken_date: null,
      },
      rules: {
        merchandise_id: [
          v => !!v || "Merchandise is required",
        ],
        merchandise_taken_by: [
          v => !!v || "Name is required",
          v => (v && v.length <= 100) || "Name must be less than 10 characters"
        ],
        amount: [
          v => !!v || "Amount is required",
          v => (v && v > 0) || "Amount must be greater than 0"
        ],
        taken_date: [
          v => !!v || "Taken date is required",
          v => (v && v.length <= 10) || "Taken date must be in format YYYY-MM-DD"
        ]
      }
    };
  },
  props: {
    module: {
      type: String
    },
    success: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("merchandise-out-log?id=" + id)
        .then(({ data }) => {
          this.data = {
            merchandise_taken_by: data.merchandise_taken_by,
            amount: data.amount,
            description: data.description,
            merchandise_id: data.merchandise_id,
            taken_date: data.taken_date,
          };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "merchandise-out-log";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
    }
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    }
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    }
  }
};
</script>
